import { Button, useComputedColorScheme } from "@mantine/core";
import { modals } from "@mantine/modals";
import ConstructionRounded from "@mui/icons-material/ConstructionRounded";
import { useSession } from "next-auth/react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import ReportForm from "./ReportForm";

export default function ReportBtn({
  questionDocumentId,
}: {
  questionDocumentId: string;
}) {
  const { data: session } = useSession();
  const colorScheme = useComputedColorScheme("light");
  return (
    <Button
      name="Suggest fix"
      pos={"absolute"}
      bottom={"0.5rem"}
      right={"0.5rem"}
      mr={0}
      ml={"auto"}
      color={colorScheme === "dark" ? "dark" : `dark.2`}
      variant={colorScheme === "dark" ? "filled" : "white"}
      size="xs"
      leftSection={
        <ConstructionRounded style={{ width: "15px", height: "15px" }} />
      }
      onClick={() =>
        modals.open({
          modalId: "Report",
          padding: "lg",
          radius: "md",
          size: "lg",
          overlayProps: { color: "darkblue", opacity: 0.75 },
          withCloseButton: true,
          centered: true,
          title: "Improve Question",
          children: (
            <GoogleReCaptchaProvider
              reCaptchaKey={
                process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY as string
              }
              scriptProps={{
                async: true,
                defer: true,
                appendTo: "head",
              }}
            >
              <ReportForm
                questionDocumentId={questionDocumentId}
                formId="Report"
                session={session}
              />
            </GoogleReCaptchaProvider>
          ),
        })
      }
    >
      Suggest fix
    </Button>
  );
}
